export const roundToPrecision = (x, n) => +x.toPrecision(n);

export const roundForJrv = (x, unit) => {
    if (unit === 'EA') {
        return +x.toFixed(0);
    }
    if (x > 1) {
        return +x.toFixed(2);
    } else {
        return +x.toPrecision(3);
    }
}
